import { FC } from 'react'

import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import {
  IBucketProduct,
  IMenuItemsBucket,
} from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'
import { convertToPrice } from 'featureSliced/shared/utils/convertToPrice'

import { WebLineComponentList } from './styled'

type WebLineComponentsProps = {
  line: IBucketProduct
}

/** the chosen components of a menu line, under its name — same content as the phone basket */
export const WebLineComponents: FC<WebLineComponentsProps> = ({ line }) => {
  const { Currency } = useMySelector((state) => state.app.companyData)
  const components = Array.isArray(line.menuItems) ? line.menuItems : []
  if (!components.length) return null

  const label = (component: IMenuItemsBucket) => {
    const count = Number(component.count) || 0
    const price = Number(component.price) || 0
    if (price > 0) {
      return `${component.name} (${count} x ${convertToPrice(price)} ${
        Currency || ''
      })`
    }
    if (count > 1) return `${component.name} (x ${count})`
    return component.name
  }

  return (
    <WebLineComponentList data-testid="web-line-components">
      {components.map((component, index) => (
        <li key={`${line.uniqueId}_${component.productId}_${index}`}>
          {label(component)}
        </li>
      ))}
    </WebLineComponentList>
  )
}
